import { Colors } from '..';
const {
  sec_purple_lighter,
  sec_purple_light,
  sec_purple,
  sec_red_lighter,
  sec_red_light,
  sec_red,
  sec_orange_lighter,
  sec_orange_light,
  sec_orange,
  sec_blue_lighter,
  sec_blue_light,
  sec_blue_dark,
  sec_yellow_lighter,
  sec_yellow_light,
  sec_yellow_dark,
  sec_green_lighter,
  sec_green_light,
  sec_green_dark
} = Colors;
export const ActivityColorPalette = {
  education: sec_purple,
  employment: sec_blue_dark,
  life: sec_green_dark,
  personal: sec_orange,
  competition: sec_yellow_dark,
  social: sec_red
};
export const ActivityColorPaletteLight = {
  education: sec_purple_light,
  employment: sec_blue_light,
  life: sec_green_light,
  personal: sec_orange_light,
  competition: sec_yellow_light,
  social: sec_red_light
};
export const ActivityColorPaletteLighter = {
  education: sec_purple_lighter,
  employment: sec_blue_lighter,
  life: sec_green_lighter,
  personal: sec_orange_lighter,
  competition: sec_yellow_lighter,
  social: sec_red_lighter
};